import React, {} from 'react';
import {
  useSlateStatic,
  useSelected,
  useFocused,
  ReactEditor,
} from 'slate-react';

import Helpers from '../../helpers';
import nodeControls from '../../node-menu/control-types';

import BaseElement from '../base';
import ImageAlignmentTool from './alignment-tool';

function Image(props) {

  const element = props.element;
  const attributes = props.attributes;

  const editor = useSlateStatic();
  const selected = useSelected();
  const focused = useFocused();

  function renderImage() {

    const imageAttributes = {
      src: element.url,
      style: {
        display: 'inline-block',
        maxWidth: '100%',
        maxHeight: '20em',
        boxShadow: 'none'
      }
    };

    if (selected === true && focused === true) {
      imageAttributes.style.boxShadow = '0 0 0 3px #B4D5FF';
    }

    const imageBlockAttributes = {
      ...attributes,
      className: 'image-node',
      contentEditable: false
    };

    const imageContainerAttributes = {
      className: 'image-node-content-container'
    };

    const imageAlignmentToolProperties = {
      onAlignmentChange(alignment) {
        Helpers.setAttributes(editor, { alignment }, ReactEditor.findPath(editor, element));
      }
    };

    return <div {...imageBlockAttributes}>
      {props.children}
      <div {...imageContainerAttributes}>
        <div className="image-tag-container">
          <ImageAlignmentTool {...imageAlignmentToolProperties} />
          <img {...imageAttributes} />
        </div>
      </div>
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      customNodeControls: [
        nodeControls.ALT_TEXT_INPUT
      ]
    };

    return <BaseElement {...baseElementProperties}>
      {renderImage()}
    </BaseElement>;

  }

  return renderMain();

}

export default Image;